import bhiotrackApi from '@/http/bhiotrack';
import { serialize } from '@/utils';

export default {
  async getInvoice(invoiceId) {
    const response = await bhiotrackApi.get(`/payment/${invoiceId}`);
    return response.data;
  },

  async getPaymentHistory(params = {}) {
    const response = await bhiotrackApi.get(`/payment${serialize(params)}`);
    return response.data;
  },

  async reprocessPayment(paymentMethodId, invoiceId) {
    const response = await bhiotrackApi.post(`/payment/reprocess`, {
      iuguPaymentMethodId: paymentMethodId,
      iuguInvoiceId: invoiceId,
    });
    return response.data;
  },
};
